import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../Components/SideBar';
import Header from '../Components/Header';
import { Button, CircularProgress, Paper, Typography, Box } from '@mui/material';
import axios from 'axios';
import BASEURL from '../Connection/BASEURL';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Renew = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [deceasedData, setDeceasedData] = useState(null);
    const [error, setError] = useState(null);
    const [feeData, setFeeData] = useState(null);
    const [feeLoading, setFeeLoading] = useState(false);
    const [allMaintenanceFees, setAllMaintenanceFees] = useState([]);
    const [refreshData, setrefreshData] = useState(false);
    const [maintenanceFeeAmount, setMaintenanceFeeAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    // Get the tblid from navigation state
    const tblid = location.state?.id;

    useEffect(() => {
        if (tblid) {
            fetchDeceasedData();
        } else {
            setError('No deceased ID provided');
        }
    }, [tblid]);

    // Fetch fee data after deceased data is loaded
    useEffect(() => {
        if (deceasedData && tblid) {
            fetchFeeData();
        }
    }, [deceasedData, tblid]);

    const fetchDeceasedData = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await axios.get(`${BASEURL}/deceased/${tblid}`);
            setDeceasedData(response.data);

            toast.success('Deceased data loaded successfully!', {
                position: toast.POSITION.TOP_CENTER
            });
        } catch (error) {
            console.log('Error fetching deceased data:', error);
            setError('Failed to load deceased data');
            toast.error('Failed to load deceased data', {
                position: toast.POSITION.TOP_CENTER
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchFeeData = async () => {
        try {
            setFeeLoading(true);

            // Get sale_of_grave from deceased data - adjust field name as needed
            const saleOfGrave = deceasedData?.sale_of_grave || deceasedData?.saleOfGrave || 'default';

            console.log('Fetching fee data with tblid:', tblid, 'sale_of_grave:', saleOfGrave);

            const response = await axios.get(`${BASEURL}/fee/${1}/${deceasedData.sale_of_grave}`);
            setFeeData(response.data);

            console.log('Fee data:', response.data);

            // Calculate maintenance fee
            calculateMaintenanceFee(response.data);

            toast.success('Fee data loaded successfully!', {
                position: toast.POSITION.TOP_CENTER
            });
        } catch (error) {
            console.log('Error fetching fee data:', error);
            toast.error('Failed to load fee data', {
                position: toast.POSITION.TOP_CENTER
            });
        } finally {
            setFeeLoading(false);
        }
    };

    const handleBack = () => {
        navigate('/all-deceased');
    };

    const handlePrintInvoice = () => {
        const invoiceData = {
            deceasedData,
            feeData,
            maintenanceFeeAmount,
            totalAmount,
            tblid
        };
        
        navigate('/renew-invoice', {
            state: {
                invoiceData
            }
        });
    };

    const handleAddPayment = () => {
        navigate('/renew-payment-list', {
            state: {
                deceasedId: tblid,
                deceasedData: deceasedData,
                maintenanceFeeAmount: maintenanceFeeAmount,
                openModal: true
            }
        });
    };

    const fetchMaintenanceFees = async () => {
        try {
            const response = await axios.get(`${BASEURL}/maintenance-fees`);
            const data = response.data;
            // Add createdAt if not present
            const maintenanceFeesWithCreatedAt = data.map(fee => ({
                ...fee,
                createdAt: fee.createdAt || new Date().toISOString()
            }));
            setAllMaintenanceFees(maintenanceFeesWithCreatedAt);
        } catch (error) {
            console.log('Error fetching maintenance fees:', error);
        }
    };

    // Calculate maintenance fee percentage
    const calculateMaintenanceFee = (feeAmount) => {
        if (allMaintenanceFees.length > 0 && feeAmount) {
            const maintenanceFeePercentage = allMaintenanceFees[0].maintainance_fees || 0;
            const calculatedAmount = (parseFloat(feeAmount) * parseFloat(maintenanceFeePercentage)) / 100;
            setMaintenanceFeeAmount(calculatedAmount);
            setTotalAmount(parseFloat(feeAmount) + calculatedAmount);

            console.log('Fee Amount:', feeAmount);
            console.log('Maintenance Fee %:', maintenanceFeePercentage);
            console.log('Calculated Maintenance Fee:', calculatedAmount);
            console.log('Total Amount:', parseFloat(feeAmount) + calculatedAmount);
        }
    };

    useEffect(() => {
        fetchMaintenanceFees();
    }, [refreshData]);

    useEffect(() => {
        fetchMaintenanceFees();
    }, []);

  return (
        <>
            <ToastContainer />
            <div className='grid grid-cols-12'>
                <div className='col-span-2 hidden lg:block'>
                    <SideBar />
                </div>
                <div className='col-span-12 lg:col-span-10 bg-[#D2D2CF]'>
                    <Header />
                    <div className='mx-8'>
                        <div className="flex items-center justify-between py-6">
                            <h1 className="text-4xl font-bold text-[#111927] py-2">
                                Renew Deceased Record
                            </h1>
                            <div>
                                
                                <Button
                                    onClick={handleBack}
                                    variant="contained"
                                    style={{ backgroundColor: '#0F1D48', color: 'white' }}
                                >
                                    Back to All Deceased
                                </Button>
                            </div>
                        </div>

                        <Paper elevation={3} className="bg-white mt-8 p-5 mb-8" style={{ borderRadius: 20 }}>
                            {loading ? (
                                <div className="flex justify-center items-center py-12">
                                    <CircularProgress size={50} style={{ color: "#122E76" }} />
                                    <Typography className="ml-4">Loading deceased data...</Typography>
                                </div>
                            ) : error ? (
                                <div className="text-center py-12">
                                    <Typography color="error" variant="h6">
                                        {error}
                                    </Typography>
                                    <Button
                                        onClick={fetchDeceasedData}
                                        variant="outlined"
                                        className="mt-4"
                                    >
                                        Retry
                                    </Button>
                                </div>
                            ) : deceasedData ? (
                                <div className="p-6">
                                    <Typography variant="h5" className="mb-4">
                                        Deceased Information (ID: {tblid})
                                    </Typography>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <Typography variant="subtitle2" color="textSecondary">
                                                First Name
                                            </Typography>
                                            <Typography variant="body1">
                                                {deceasedData.fname || 'N/A'}
                                            </Typography>
                                        </div>

                                        <div>
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Last Name
                                            </Typography>
                                            <Typography variant="body1">
                                                {deceasedData.lname || 'N/A'}
                                            </Typography>
                                        </div>

                                        <div>
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Gender
                                            </Typography>
                                            <Typography variant="body1">
                                                {deceasedData.gender || 'N/A'}
                                            </Typography>
                                        </div>

                                        <div>
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Date of Death
                                            </Typography>
                                            <Typography variant="body1">
                                                {deceasedData.dod || 'N/A'}
                                            </Typography>
                                        </div>

                                        <div>
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Bed Location
                                            </Typography>
                                            <Typography variant="body1">
                                                {deceasedData.bed || 'N/A'}
                                            </Typography>
                                        </div>

                                        <div>
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Age
                                            </Typography>
                                            <Typography variant="body1">
                                                {deceasedData.Aged || 'N/A'}
                                            </Typography>
                                        </div>
                                    </div>

                                    {/* Fee Calculation Section */}
                                    {feeLoading ? (
                                        <Box className="mt-6 p-4 bg-blue-50 rounded">
                                            <div className="flex items-center">
                                                <CircularProgress size={20} style={{ color: "#122E76" }} />
                                                <Typography className="ml-2">Loading fee data...</Typography>
                                            </div>
                                        </Box>
                                    ) : feeData ? (
                                        <Box className="mt-6 p-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg border-2 border-green-200">
                                            <Typography variant="h5" className="mb-4 text-green-800 font-bold">
                                                💰 Fee Calculation & Invoice
                                            </Typography>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                                <Box className="p-4 bg-white rounded-lg shadow-sm">
                                                    <Typography variant="subtitle2" color="textSecondary" className="mb-1">
                                                        Base Fee Amount
                                                    </Typography>
                                                    <Typography variant="h4" className="text-green-600 font-bold">
                                                        GH₵ {Number(feeData).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </Typography>
                                                </Box>

                                                <Box className="p-4 bg-white rounded-lg shadow-sm">
                                                    <Typography variant="subtitle2" color="textSecondary" className="mb-1">
                                                        Maintenance Fee ({allMaintenanceFees[0]?.maintainance_fees || 0}%)
                                                    </Typography>
                                                    <Typography variant="h4" className="text-blue-600 font-bold">
                                                        GH₵ {Number(maintenanceFeeAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </Typography>
                                                </Box>
                                            </div>

                                            <Box className="p-4 bg-gradient-to-r from-green-100 to-blue-100 rounded-lg border-2 border-green-300">
                                                <div className="flex justify-between items-center">
                                                    <Typography variant="h5" className="text-gray-800 font-bold">
                                                        Final Renewal Amount
                                                    </Typography>
                                                    {/* GH₵ {Number(maintenanceFeeAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} */}
                                                    <Typography variant="h3" className="text-green-700 font-bold">
                                                        GH₵ {Number(maintenanceFeeAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </Typography>

                                                    {/* <Typography variant="h3" className="text-green-700 font-bold">
                                                        GH₵ {Number(totalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </Typography> */}
                                                </div>
                                            </Box>

                                            <div className="mt-4 flex justify-center space-x-4">
                                                <Button 
                                                    onClick={handleAddPayment}
                                                    variant="contained"
                                                    size="large"
                                                    style={{ 
                                                        backgroundColor: "#22C55E", 
                                                        color: "white",
                                                        padding: "12px 32px",
                                                        fontSize: "16px",
                                                        fontWeight: "bold"
                                                    }}
                                                    className="shadow-lg hover:shadow-xl transition-all duration-300"
                                                >
                                                    💳 Add Payment
                                                </Button>
                                                <Button 
                                                    onClick={handlePrintInvoice}
                                                    variant="contained"
                                                    size="large"
                                                    style={{ 
                                                        backgroundColor: "#0F1D48", 
                                                        color: "white",
                                                        padding: "12px 32px",
                                                        fontSize: "16px",
                                                        fontWeight: "bold"
                                                    }}
                                                    className="shadow-lg hover:shadow-xl transition-all duration-300"
                                                >
                                                    🖨️ Print Invoice
                                                </Button>
                                            </div>
                                        </Box>
                                    ) : (
                                        <Box className="mt-6 p-4 bg-yellow-50 rounded">
                                            <Typography variant="body2" className="text-yellow-700">
                                                No fee data available
                                            </Typography>
                                        </Box>
                                    )}

                                    {/* <Box className="mt-6 p-4 bg-gray-50 rounded">
                                        <Typography variant="h6" className="mb-2">
                                            Raw Deceased Data:
                                        </Typography>
                                        <pre className="text-xs overflow-auto">
                                            {JSON.stringify(deceasedData, null, 2)}
                                        </pre>
                                    </Box> */}
                                </div>
                            ) : (
                                <div className="text-center py-12">
                                    <Typography variant="h6">
                                        No data available
                                    </Typography>
                                </div>
                            )}
                        </Paper>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Renew;